import './split-hero.scss';
